import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0;
import { action, computed, observable } from 'mobx';
import { Client } from 'core/util/sseConnect';
import $auth from 'app/stores/$auth';
import { isBatchedEvaluationResult, isCompleteType, isEvaluationResult, isTotalDevices } from 'app/stores/interface/types';
let RuleState = (_dec = observable.shallow, _class = class RuleState {
  constructor(options) {
    _initializerDefineProperty(this, "rule", _descriptor, this);
    _initializerDefineProperty(this, "complete", _descriptor2, this);
    _initializerDefineProperty(this, "evaluating", _descriptor3, this);
    _initializerDefineProperty(this, "devicesCompleted", _descriptor4, this);
    _initializerDefineProperty(this, "devicesRemaining", _descriptor5, this);
    _initializerDefineProperty(this, "batchIndex", _descriptor6, this);
    _initializerDefineProperty(this, "batchSize", _descriptor7, this);
    _initializerDefineProperty(this, "evaluationResults", _descriptor8, this);
    _initializerDefineProperty(this, "ruleMatchCount", _descriptor9, this);
    this.deviceMatches = {};
    this.ruleInterfaceMatches = {};
    this.deviceCollection = void 0;
    this.ruleCollection = void 0;
    this.settings = void 0;
    this.onSuccess = void 0;
    this.onError = void 0;
    this.sseClient = void 0;
    /**
     *  Comes in 3 parts: `totalDevices` is the first response, followed by a bunch of devices
     *  and then followed by `complete: true`
     */
    _initializerDefineProperty(this, "handleData", _descriptor0, this);
    const {
      onSuccess,
      onError,
      ruleCollection,
      deviceCollection,
      settings
    } = options;
    this.onSuccess = onSuccess;
    this.onError = onError;
    this.ruleCollection = ruleCollection;
    this.deviceCollection = deviceCollection;
    this.settings = settings;
    this.reset();
    this.sseClient = new Client({
      outType: 'classifyInterfaces',
      inType: 'classification',
      onSuccess: this.handleData,
      onError: this.handleData
    });
    this.sseClient.on('reconnect', () => {
      this.reset();
      this.setEvaluationComplete(true);
    });
  }
  reset() {
    this.rule = null;
    this.complete = false;
    this.evaluating = false;
    this.devicesCompleted = 0;
    this.devicesRemaining = 0;
    this.ruleMatchCount = 0;
    this.evaluationResults.clear();
    this.ruleInterfaceMatches = {};
    this.deviceMatches = {};
  }
  send(params) {
    this.evaluating = true;
    this.complete = false;
    this.evaluationResults.clear();
    this.deviceMatches = {};
    this.ruleInterfaceMatches = {};
    this.sseClient.send(params);
  }
  addEvaluationResult(data) {
    this.evaluationResults.push(data);

    // set up device match info
    const {
      device_id,
      matchInfo = {},
      rules = [],
      interfaces = []
    } = data;
    if (device_id !== undefined) {
      const {
        interfaceCount = 0,
        interfacesClassifiedCount = 0,
        rulesUsed = 0
      } = matchInfo;
      this.deviceMatches[device_id] = {
        interfaceCount,
        interfacesClassifiedCount,
        rulesUsed,
        percentMatched: interfaceCount > 0 ? interfacesClassifiedCount / interfaceCount : 0,
        rules,
        interfaces
      };
    }
    let classifiedCount = 0;

    // set up rule interface match info
    rules.forEach(rule => {
      const {
        id,
        interfacesMatched,
        interfacesClassified
      } = rule;
      if (!this.ruleInterfaceMatches[id]) {
        this.ruleInterfaceMatches[id] = {
          interfacesMatched: [],
          interfacesClassified: []
        };
      }
      const matchedRule = this.ruleInterfaceMatches[id];
      matchedRule.interfacesMatched.push(...interfacesMatched);
      matchedRule.interfacesClassified.push(...interfacesClassified);
      // only include rule-based matches in classification count
      if (id !== -1) {
        classifiedCount += interfacesClassified.length;
      }
    });
    this.ruleMatchCount += classifiedCount;
  }
  setEvaluationComplete(complete) {
    this.complete = complete;
  }
  get totalDevices() {
    return this.deviceCollection.unfiltered.filter(i => i.get('device_status') === 'V').length;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "rule", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "complete", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "evaluating", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "devicesCompleted", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "devicesRemaining", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "batchIndex", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "batchSize", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "evaluationResults", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "ruleMatchCount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "reset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "send", [action], Object.getOwnPropertyDescriptor(_class.prototype, "send"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setEvaluationComplete", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setEvaluationComplete"), _class.prototype), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "handleData", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return data => {
      const {
        totalDevices
      } = this;
      let {
        devicesCompleted,
        devicesRemaining,
        batchIndex,
        batchSize
      } = this;
      let complete = false;
      this.ruleMatchCount = 0;

      // after the test is complete, update the DeviceCollection with the results.
      if (isCompleteType(data)) {
        complete = true;
        devicesCompleted = totalDevices;
        devicesRemaining = 0;
        $auth.verifyAuth().then(action(() => {
          this.evaluating = false;
        }));
        this.deviceCollection.sort();
      } else if (isTotalDevices(data)) {
        devicesRemaining = data.totalDevices;
        devicesCompleted = 0;
      } else if (isBatchedEvaluationResult(data)) {
        batchIndex = data.batchIndex;
        batchSize = data.batchSize;
        if (data.aggregateMode && data.phase === 'complete') {
          data.results.forEach(result => {
            this.addEvaluationResult(result);
            if (this.deviceCollection.get(result.device_id)) {
              devicesCompleted += 1;
              devicesRemaining -= 1;
            }
          });
        }
      } else if (isEvaluationResult(data)) {
        this.addEvaluationResult(data);
        if (this.deviceCollection.get(data.device_id)) {
          devicesCompleted += 1;
          devicesRemaining -= 1;
        }
      }
      this.complete = complete;
      this.devicesCompleted = devicesCompleted;
      this.devicesRemaining = devicesRemaining;
      this.batchIndex = batchIndex;
      this.batchSize = batchSize;
      this.deviceCollection.updateDeviceInterfaceMatchData(this.deviceMatches);
      if (this.ruleCollection) {
        this.ruleCollection.updateRuleInterfaceMatchData(this.ruleInterfaceMatches);
      }
      if (this.onSuccess) {
        this.onSuccess(data);
      }
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "totalDevices", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalDevices"), _class.prototype), _class);
export default RuleState;